import type { FormLevelFeature } from "@/entities/form-metadata";
import { FormLevelFeatureType } from "@/entities/form-metadata";

export const isNonVisual = (features: FormLevelFeature[]): features is [FormLevelFeature] =>
    features.length === 1 &&
    !!features[0] &&
    (features[0].featureType === FormLevelFeatureType.SearchAssistModal ||
        features[0].featureType === FormLevelFeatureType.CollapsibleStart ||
        features[0].featureType === FormLevelFeatureType.CollapsibleEnd);
